<template>
    <AddBonAncien />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddBonAncien from "@/components/GesCom/BonAncien/AddBonAncien.vue";
  
    export default defineComponent({
      name: "AddBonAncienPage",
      components: {
        
        AddBonAncien,
      },
    });
  </script>